module.exports = __webpack_public_path__ + "img/special_bihakulotion_202402.bd5304f7.jpg";